export default "__VITE_ASSET__bUInisjt__"